module.exports = __webpack_public_path__ + "img/logo_login.be9ffe5a.png";